import { motion } from 'motion/react'
import type { CSSProperties } from 'react'
import { useEffect, useRef, useState } from 'react'
import { twMerge } from 'tailwind-merge'

export function ImageWithLoadAnimation(props: {
  src?: string
  alt?: string
  wrapperClassName?: string
  wrapperStyle?: CSSProperties
  className?: string
  style?: CSSProperties
}) {
  const imgRef = useRef<HTMLImageElement>(null)
  const [hasImageLoaded, setHasImageLoaded] = useState(false)
  const { wrapperClassName, className, wrapperStyle, style, src, alt } = props
  useEffect(() => {
    const img = imgRef.current
    if (img && img.complete && img.naturalHeight !== 0) {
      setHasImageLoaded(true)
    }
  }, [])
  return (
    <div
      className={twMerge(
        'overflow-hidden transition',
        hasImageLoaded
          ? 'bg-transparent'
          : 'bg-neutral-200 dark:bg-neutral-600',
        wrapperClassName,
      )}
      style={wrapperStyle}
    >
      <motion.img
        initial={false}
        animate={{
          opacity: hasImageLoaded ? 1 : 0,
        }}
        className={twMerge('w-full h-full object-cover', className)}
        style={style}
        src={src}
        alt={alt}
        ref={imgRef}
        onLoad={() => {
          setHasImageLoaded(true)
        }}
      />
    </div>
  )
}
